import { endOfDay, toDate } from '@qover/utils/src/date';
import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/travel/v1/contract';
import { TripType } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import { DraftMapper } from '@qover/domain';
import { Draft } from '../Draft';
import * as RiskMapper from './RiskMapper';
import * as TermsMapper from './TermsMapper';

export function mapToApiRequest(draft: Draft): DraftProtos {
  const risk = RiskMapper.mapToApiRequest(draft.risk);
  const terms = TermsMapper.mapToApiRequest(draft.terms);
  const draftRequest = DraftMapper.mapToApiRequest(draft);

  const endDate =
    draft.endDate && draft.terms?.tripType === TripType.TRIP_TYPE_SINGLE_TRIP
      ? endOfDay(toDate(draft.endDate)).toISOString()
      : undefined;

  return {
    ...draftRequest,
    endDate,
    risk,
    terms,
    previousVersions: [],
    nextVersion: undefined,
  };
}
